import { Box } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

interface IActiveFiltersBubble {
  activeFiltersAmount: number;
}

export const ActiveFiltersBubble = ({
  activeFiltersAmount,
}: IActiveFiltersBubble) => {
  return (
    <Box
      aria-label={`${activeFiltersAmount} ${
        Dictionary[DICTIONARY.Suppliers].resultPage.chosenFilter
      }`}
      sx={{
        position: 'absolute',
        zIndex: 1,
        top: '-5px',
        right: '-5px',
        bgcolor: 'primary.main',
        color: '#FFF',
        borderRadius: '50%',
        width: '24px',
        height: '24px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {activeFiltersAmount}
    </Box>
  );
};
